export const APP_DISPLAY_NAMES = {
  'stock-tracker': 'Stock Tracker',
};

export function getAppDisplayName(appName) {
  return APP_DISPLAY_NAMES[appName] || appName;
}
